import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { kPitchPaletteLength } from "@/shared/modal.api";
import type { ParameterRange } from "@/shared/parameter-range";
import { isObject } from "@/shared/utils/typeGuards";

export const kMagicFit40Route = "/magic-fit-4.0";

export { kPitchPaletteLength };

// Magic Fit uses its own complexity default, unlike Variations 4.0 / Inpainting
// 4.0 which share kComplexity30Range from modal.api.
export const kComplexity40Range: ParameterRange = { min: 0, max: 1, default: 0.69 };

export const kVariationRange: ParameterRange = { min: 0, max: 1, default: 0.09 };
export const kBalanceRange: ParameterRange = { min: 0, max: 1, default: 0.27 };

export interface MagicFit40RequestBody {
    drivingAudioKey: string;
    timbreAudioKey: string;
    bpm: number;
    pitchPalette?: number[];
    variation?: number;
    balance?: number;
    complexity?: number;
}

export const isMagicFit40RequestBody = (value: unknown): value is MagicFit40RequestBody =>
    isObject(value) &&
    typeof value.drivingAudioKey === "string" &&
    typeof value.timbreAudioKey === "string" &&
    typeof value.bpm === "number";

export const kMagicFit40Endpoint: ApiEndpoint<MagicFit40RequestBody, DownloadUrlResponse> = {
    route: kMagicFit40Route,
    label: "Magic Fit 4.0",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v4.0",
    description:
        "Magic Fit using the SpliceGen 4.0 model with complexity control over the timbre transfer.",
    isRequestBody: isMagicFit40RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
